<script setup>
import { VueFinalModal } from 'vue-final-modal'
const emit = defineEmits(['close']);
</script>

<template>
  <VueFinalModal
    :click-to-close="false"
    :lock-scroll="true"
    content-transition="vfm-slide-down"
    overlay-transition="vfm-fade"
    class="vfm__core"
  >
  <template #default="{ close }">
    <div class="vfm__content-outer">
        <div class="vfm__content-inner">
            <button class="vfm__close" type="button" @click="emit('close')"></button>
            <slot />
        </div>
        </div>
    </template>
  </VueFinalModal>
</template>

<style lang="scss">
.vfm {
    &--overlay {
        pointer-events: none;
        transition: all 0.3s linear;
        backdrop-filter: blur(9px);
        isolation: isolate;
    }
    &__core {
        inset: 0;
    }
    &__content {
        position: absolute;
        inset: 0;

        @media (min-width: 576px) {
            overflow: auto;
            height: 100%;
        }

        &-outer {
            position: absolute;
            inset: 0;
            height: 100%;
            overflow: auto;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            
            @media (min-width: 576px) {
                justify-content: center;
            }
        }
        &-inner {
            display: flex;
            flex-direction: column;
            inset: 0;
            bottom: 0;
            top: initial;
            width: 100%;
            position: absolute;
            max-height: calc(100vh - 1rem);
            max-height: calc(100svh - 1rem);
            max-width: calc(100vw - 1rem);
            max-width: calc(100svw - 1rem);
            margin: 0.5rem;
            border-radius: 0.5rem;
            overflow: hidden;

            &::before {
                content: "";
                width: 60px;
                height: 4px;
                background-color: RGBA(255, 255, 255, 0.31);
                border-radius: 4px;
                display: block;
                position: absolute;
                top: -20px;
                transform: translateX(-50%);
                left: 50%;
            }
            @media (min-width: 576px) {
                position: relative;
                bottom: initial;
                max-width: 36rem;
                margin-left: auto;
                margin-right: auto;
                min-height: auto;
                box-shadow: 0 6px 6px rgba(0, 0, 0, 0.2), 0 0 20px rgba(0, 0, 0, 0.1);
            }
        }
    }
    &__close {
        position: absolute;
        right: 0.5rem;
        top: 0.5rem;
        z-index: 2;
        width: 2.5rem;
        height: 2.5rem;
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 99px;
        overflow: hidden;
        backdrop-filter: blur(10px);
        outline: none;
        padding: 0;
        display: block;
        line-height: 1;
        box-shadow: none;

        &::before,
        &::after {
            content: '';
            display: block;
            width: 40%;
            height: 2px;
            background-color: #777777;
            top: 50%;
            left: 50%;
            transform-origin: center;
            position: absolute;
        }
        &::before {
            transform: translate3d(-50%, -50%, 0) rotate(-45deg);
        }
        &::after {
            transform: translate3d(-50%, -50%, 0) rotate(45deg);
        }
    }
}

</style>